import Simplemodal from '../../plugins/simplemodal.js';

// スクロール先を保存する変数
let pendingScrollTarget = null;

const fullScreenMenu = new Simplemodal({
  trigger: "data-fullScreenMenu-trigger",
  clickOutSideClose: true,
  onClose: (trigger, content) => {
    // メニューが閉じた後にスクロール処理を実行
    if (pendingScrollTarget) {
      setTimeout(() => {
        const targetElement = document.querySelector(pendingScrollTarget);
        if (targetElement) {
          const headerHeight = document.querySelector('.l-header')?.offsetHeight || 0;
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
        pendingScrollTarget = null;
      }, 100);
    }
  }
});

// アンカーリンクのクリックイベントを処理
function initAnchorLinks() {
  document.querySelectorAll('.js-fullScreenMenu-toggle a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href');
      if (href && href !== '#') {
        // メニューが開いている場合のみ処理
        const menuContent = document.getElementById('js-fullScreenMenu-content');
        const isMenuOpen = menuContent && (
          menuContent.classList.contains('is-open') || 
          menuContent.getAttribute('aria-hidden') === 'false'
        );
        
        if (isMenuOpen) {
          // デフォルトのスクロール動作を防ぐ
          e.preventDefault();
          
          // スクロール先を保存（onCloseコールバックで使用）
          pendingScrollTarget = href;
          
          // メニューを閉じる: 開いているトリガー（aria-expanded="true"のボタン）を見つけてクリック
          const openTrigger = document.querySelector('button[data-fullScreenMenu-trigger="js-fullScreenMenu-content"][aria-expanded="true"]');
          if (openTrigger) {
            openTrigger.click();
          } else {
            // フォールバック: 閉じるボタンを直接探す（メニュー内の閉じるボタン）
            const closeButton = document.querySelector('.l-header-menu-button button[data-fullScreenMenu-trigger="js-fullScreenMenu-content"]');
            if (closeButton) {
              closeButton.click();
            } else {
              // 最後の手段: closeメソッドを直接呼び出す
              fullScreenMenu.close('js-fullScreenMenu-content');
            }
          }
        }
      }
    });
  });
}

// DOMContentLoadedで実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnchorLinks);
} else {
  initAnchorLinks();
}